// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1_jnA","cls2":"SuggestionCard-cls2__ry SuggestionCard-cls1_jnA"};